import { forwardRef } from 'react';

import * as LabelPrimitive from '@radix-ui/react-label';
import { cva } from 'class-variance-authority';

import { cn } from '/src/shared/utils';

const labelVariants = cva(
  'text-lg font-light leading-none tracking-wide peer-disabled:cursor-not-allowed peer-disabled:opacity-70'
);

const Label = forwardRef(({ className, ...props }, ref) => (
  <LabelPrimitive.Root
    ref={ref}
    className={cn(labelVariants(), className)}
    {...props}
  />
));
Label.displayName = LabelPrimitive.Root.displayName;

export { Label };
